import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Icon = styled(FontAwesomeIcon)`
    margin: 12px auto;
    font-size: 20px;
`;

export const IconDiv = styled.div`
    background-color: ${({ theme }) => theme.colors.primary300};
    border-radius: 50%;
    color: white;
    width: 44px;
    height: 44px;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    position: absolute;
    cursor: pointer;
`;

export const PlaceHolderDiv = styled.div`
    width: ${({ imageWidth }) => imageWidth}px;
    height: ${({ computedHeight }) => computedHeight}px;
    padding-top: ${({ paddingTop }) => paddingTop}px;
    padding-bottom:${({ paddingBottom }) => paddingBottom}px;
    padding-left:${({ paddingLeft }) => paddingLeft}px;
    padding-right:${({ paddingRight }) => paddingRight}px;
    position: relative;
    display: block;
`;

export const ContentOverlay = styled.div`
    background: ${({ theme }) => theme.colors.primary300};
    opacity: 0.2;
    position: absolute;
    height: 99%;
    width: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
`;

export const ImageElementDiv = styled.div`
    position: relative;
    background-color: ${({ theme }) => theme.colors.neutral000};
    width: 100%;
    height: ${({ placeHolderImageDimension }) => placeHolderImageDimension};
    text-align: center;
`;

export const ImageDimensionText = styled.p`
    font-size: 16px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.neutral700};
    position: absolute;
    width: ${({ imageWidth }) => imageWidth}px;
    text-align: center;
    bottom: ${({ placeHolderImageDimension }) => `calc(100% - ${placeHolderImageDimension - 6}px)`};
`;
